import { createFileRoute } from "@tanstack/react-router";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { AthleteQuestionnaireSubmissionLayout } from "src/pages/AthleteQuestionnaireSubmissionLayout";
import { createOrganizationQuestionnairesRepository } from "src/repositories/questionnaires/createOrganizationQuestionnairesRepository";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId",
)({
  component: RouteComponent,
  ssr: true,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => ({
        data: await context.queryClient.query({
          ...createOrganizationQuestionnairesRepository(
            organization.id,
          ).submissionOptions(
            params.athleteId,
            params.questionnaireId,
            params.submissionId,
          ),
          staleTime: "static",
        }),
      }),
    );
  },
});

function RouteComponent() {
  const { submissionId } = Route.useParams();
  return <AthleteQuestionnaireSubmissionLayout submissionId={submissionId} />;
}
